<template>
  <div width="100%" class="pa-2 text-center">
    <v-card elevation="0">
      <v-card-title>
        {{ $t('message.edit_member') }}
      </v-card-title>
      <v-card-text>
        <v-autocomplete hide-details dense v-model="selectedMemberId" :items="members" :loading="loadingMembers"
          outlined clearable :menu-props="{ closeOnContentClick: true, offsetY: true, top: true }"
          style="font-size:large" item-text="displayName" item-value="_id" :label="$t('message.name')" height="70">
          <template v-slot:item="data">
            <v-list-item v-bind="data.attrs" :input-value="data.selected" @click="selectMember(data.item)">
              <v-list-item-content>
                <v-list-item-title v-html="data.item.displayName" style="font-size:large;color:gray">
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
      </v-card-text>
      <div v-if="selectedMemberId" class="mt-2">
        <v-divider></v-divider>
        <v-card-text class="text-center">
          <h1>{{ memberName }}</h1>
        </v-card-text>
        <div class="text-center mt-3">
          <div class="camera-container">
            <div v-show="showSelfieArea" style="width: 320px; height: 320px; overflow: hidden;">
              <video ref="video" autoplay playsinline muted
                style="width: 320px; height: 320px; object-fit: cover;"></video>
            </div>
            <canvas ref="canvas" style="display: none;"></canvas>
            <div class="controls">
              <v-btn large elevation="0" v-show="!cameraOn && !showSelfieArea && !selfieImage" small color="primary"
                @click="startCamera">{{
                  $t('message.start_camera')
                }}</v-btn>
              <v-btn elevation="0" v-show="cameraOn" small color="primary" @click="takeSelfie">{{
                $t('message.take_selfie') }}</v-btn>
              <v-btn elevation="0" v-show="cameraOn" small @click="stopCamera">{{ $t('message.stop_camera') }}</v-btn>
            </div>
            <div v-if="selfieImage">
              <img :src="selfieImage" alt="Your selfie" />
              <div v-if="uploadingImage" class="mb-1">
                <v-progress-linear buffer-value="5" color="success" height="15" stream :value="uploadPercentage">
                </v-progress-linear>
              </div>
              <v-card-actions v-show="selfieImage">
                <v-spacer></v-spacer>
                <v-btn elevation="0" v-if="!uploadingImage" small color="primary" outlined @click="retake()">
                  <v-icon class="mr-1">mdi-sync</v-icon>
                  {{ $t('message.retake_selfie')
                  }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn elevation="0" large :loading="uploadingImage" small color="primary" @click="uploadImage">{{
                  $t('message.submit')
                  }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import Api from "@/services/Api";
//import SelfieInput from '@/components/inputs/SelfieInput.vue';
//<SelfieInput v-if="selectedMemberId" :member-id="selectedMemberId"></SelfieInput>
export default {
  name: 'Checkin',
  data() {
    return {
      memberId: this.$route.query.m,
      loadingMembers: true,
      selectedMemberId: null,
      members: [],
      memberName: null,
      stream: null,
      selfieImage: null,
      showSelfieArea: false,
      uploadPercentage: 0,
      cameraOn: false,
      uploadingImage: false,
    }
  },
  created() {
    this.getMembers();
  },
  beforeDestroy() {
    this.stopCamera();
  },
  components: {
  },
  methods: {
    retake() {
      this.selfieImage = null;
      this.startCamera();
    },
    async startCamera() {
      try {
        this.cameraOn = true;
        let video = this.$refs.video;
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "user" },
          audio: false,
        });
        video.srcObject = stream;
        video.width = 320;
        video.height = 320;
        this.stream = stream;
        this.showSelfieArea = true;
      } catch (error) {
        console.error("Error accessing camera:", error);
        alert("Could not access the camera.");
      }
    },
    takeSelfie() {
      const video = this.$refs.video;
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext("2d");

      // Determine the size of the square to crop (smallest dimension of the video feed)
      const size = Math.min(video.videoWidth, video.videoHeight);

      // Set the canvas to this square size (no resizing, same resolution)
      canvas.width = size;
      canvas.height = size;

      // Calculate the starting x/y to center the square crop
      const xOffset = (video.videoWidth - size) / 2;
      const yOffset = (video.videoHeight - size) / 2;

      // Draw the square region to the canvas, preserving resolution
      ctx.drawImage(
        video,
        xOffset, yOffset, // source x/y
        size, size,       // source width/height (crop square)
        0, 0,             // target x/y in canvas
        size, size        // target width/height in canvas
      );

      // Save the canvas as a dataURL
      this.selfieImage = canvas.toDataURL("image/png");
      this.showSelfieArea = false;
      this.cameraOn = false;
      this.stopCamera();
    },
    stopCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
        this.stream = null;
        this.showSelfieArea = false;
        this.cameraOn = false;
      }
    },
    uploadImage() {
      this.uploadingImage = true;
      // Get the content type
      var contentType = 'png';
      // Convert to blob
      var blob = this.dataURLtoBlob(this.selfieImage);
      try {
        const vm = this;
        const d = new Date();
        const formData = new FormData();
        const millis = d.getTime();
        formData.append("image", blob, 'bjjlink-user-cropped-kiosk-uploaded-image-' + millis + '.' + contentType);
        Api().post("content/img/cropped", formData, {//Cropped always creates a small version
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            const percent = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
            if (percent >= 97)
              vm.uploadPercentage = 97;//Stay on 97
            else
              vm.uploadPercentage = percent;
          },
        })
          .then(res => {
            if (res) {
              setTimeout(function () {
                //vm.callWhenDone(res.data.location, vm.vm, res.data.smallImageLocation);
                vm.submitUpdatePicture(res.data);
                //this.callWhenDone(res.data.location, this.vm);

                vm.uploading = false;
              }, 4000);
            }
          })
          .catch(err => {
            this.uploadingImage = false;
            if (err)
              this.showAlert('error', this.$t('message.oops_not_working'));
          });
      } catch (err) {
        console.log('WTF?????', err);
        this.showAlert('error', this.$t('message.oops_not_working'));
      }
    },
    dataURLtoBlob(dataURL) {
      const arr = dataURL.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new Blob([u8arr], { type: mime });
    },
    submitUpdatePicture(data) {

      const newImage = data.location;
      const smallerFile = data.smallImageLocation;
      Api()
        .patch("admintablet/academy/" + this.$store.state.tabletManagedAcademy + "/member/" + this.selectedMemberId + '/image',
          {
            userImage: newImage,
            userImageSmall: smallerFile
          })
        .then(response => {
          if (response) {
            this.navigateTo({ name: 'checkin' });
          }
        })
        .catch(e => {
          this.uploadingImage = false;
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    successFunction: function (uploadedFileData, vm) {
      if (uploadedFileData && vm) {
        vm.submitUpdatePicture(uploadedFileData, vm);
      }
    },
    getMembers() {
      Api()
        .post(
          "admintablet/academy/" +
          this.$store.state.tabletManagedAcademy +
          "/users?source=members"
        )
        .then(response => {
          this.members = response.data.users;
          this.loadingMembers = false;

          if (this.memberId && this.memberId != "") {
            for (const m of this.members) {
              if (m._id.toString() == this.memberId) {
                this.selectedMemberId = this.memberId;
                this.selectMember(m)
                break;
              }
            }
          }
        });
    },
    selectMember(member) {
      this.memberName = member.displayName;
      this.selectedMemberId = member._id;
    },
  }
}
</script>

<style scoped>
.camera-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

video,
img {
  width: 320px;
  height: 320px;
  object-fit: cover;
  border: 2px solid #333;
  border-radius: 8px;
  margin-bottom: 10px;
}

.controls button {
  margin: 5px;
}
</style>
